var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { RouteNameEnum } from '@/router/RouteName';
let SetMfaPage = class SetMfaPage extends Vue {
    constructor() {
        super(...arguments);
        this.isLoading = false;
        this.isError = false;
        // // File structure for Typescript files in your Vue project
        // // https://tutorials.atabix.com/frontend/typscript_file_structure/
        // // #region @Props
        // @Prop()
        // protected isDialog!: boolean;
        // @Prop()
        // protected userId!: string;
        // @Prop()
        // protected user!: User;
        // // #endregion
        // // #region @Refs
        // // #endregion
        // // #region Class properties
        // protected currentStep = 1;
        // protected isLoading = false;
        // protected mfaOutput: null | {
        //   secret?: string;
        //   image?: string;
        // } = null;
        // protected mfaToken1 = '';
        // protected mfaToken2 = '';
        // protected isLoadingMfaToken = false;
        // // #endregion
        // // #region Lifecycle Hooks / Init
        // protected mounted(): void {
        //   this.initialize();
        // }
        // protected initialize(): void {
        //   this.generateNewMfaToken();
        // }
        // // #endregion
        // // #region Class methods
        // protected getUpdateMfaPayload(): {
        //   token?: string;
        //   token_verify?: string;
        //   secret?: string;
        //   } {
        //   return {
        //     secret: this.mfaOutput && this.mfaOutput.secret ? this.mfaOutput.secret : undefined,
        //     token: this.mfaToken1,
        //     token_verify: this.mfaToken2,
        //   };
        // }
        // protected onClickLogout(): void {
        //   // const user: User = this.$store.getters.user;
        //   this.$store.dispatch('userDeauthenticated');
        //   this.$router.push({ name: RouteNameEnum.HOME });
        // }
        // protected setMfaBooleanToTrueOnStoredUser(): void {
        //   const user: User = this.$store.getters.user;
        //   user.has_mfa_token = true;
        //   this.$store.dispatch('userAuthenticated', user);
        // }
        // protected async onRequestToGenerateNewMfaToken(): Promise<void> {
        //   await this.generateNewMfaToken();
        // }
        // protected async onUpdateMfaButtonClick(): Promise<void> {
        //   await this.updateMfa();
        // }
        // // #endregion
        // // #region Async methods
        // protected async generateNewMfaToken(): Promise<void> {
        //   this.isLoadingMfaToken = true;
        //   try {
        //     this.mfaOutput = await rpcClient.execute('mfa:generate', {});
        //   } catch (error) {
        //     // do nothing
        //   }
        //   this.isLoadingMfaToken = false;
        // }
        // protected async updateMfa(): Promise<void> {
        //   if (! this.canUpdateMfaToken) { return; }
        //   this.isLoading = true;
        //   try {
        //     this.mfaOutput = await rpcClient.execute('mfa:update', this.getUpdateMfaPayload());
        //     this.setMfaBooleanToTrueOnStoredUser();
        //     Dialog.successClose({
        //       title: this.$tc('dialog_success_set_mfa_title'),
        //       text: this.$tc('dialog_success_set_mfa_text'),
        //       buttons: {
        //         confirm: {
        //           action: () => {
        //             if (this.user) {
        //               this.$set(this.user, 'has_mfa_token', true);
        //             } else {
        //               this.$router.push({ name: RouteNameEnum.LOGIN });
        //             }
        //           },
        //         },
        //       },
        //     });
        //   } catch (error) {
        //     // do nothing
        //   }
        //   this.isLoading = false;
        // }
        // // #endregion
        // // #region Getters & Setters
        // protected get canUpdateMfaToken(): boolean {
        //   return !! (this.mfaOutput && ! this.isLoading && this.mfaTokensValid);
        // }
        // protected get mfaTokensValid(): boolean {
        //   return this.mfaToken1.length === 6 && this.mfaToken2.length === 6;
        // }
        // // #endregion
        // // #region @Watchers
        // // #endregion
    }
    async onLogout() {
        await Promise.all([
            this.$store.dispatch('isLoading', true),
            this.$store.dispatch('userDeauthenticated'),
            this.$store.dispatch('setIsStoreInitialized', false),
        ]);
        this.$router.push({ name: RouteNameEnum.LOGIN }).catch(() => { });
    }
};
SetMfaPage = __decorate([
    Component({})
], SetMfaPage);
export default SetMfaPage;
